import { AxiosInstance } from "axios";
import { URL } from "../../../libraries/http/url";
import { Predicates } from "../../../libraries/predicates/predicates";
import { SearchParams } from "../../../types/search-params";
import { PageableDTO } from "../../../types/pageable";
import useAxios from "../../../utils/useAxios";
import { useEffect, useState } from "react";
import { MasterArtworkNameState } from "states/meta-artwork/artwork-name/data.type";


type ArtworNameResponse =
  | PageableDTO<MasterArtworkNameState[]>
  | MasterArtworkNameState[];

export const fetchArtworkName = async ({
  search,
  axios,
}: SearchParams & { axios: AxiosInstance }) => {
  try {
    const searchParams = URL.createSearchParams({
      search,
      limit: 50,
    });

    const response = await axios.get<ArtworNameResponse>(
      `/artwork-master/meta-artwork/name/?${searchParams.toString()}`,
    );

    return Predicates.parsePageableReponseToType(response);
  } catch (err) {
    console.error(err);
  }
  return [];
};

export default function useArtworkName({ search }: SearchParams) {
  const axios = useAxios();
  const [data, setData] = useState<MasterArtworkNameState[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    const getData = async () => {
      setIsLoading(true);
      const response = await fetchArtworkName({
        search,
        axios,
      });

      setData(response);
      setIsLoading(false);
    };
    getData();
  }, [search]);

  return { data, isLoading };
}
